import React from 'react';
import { useState } from 'react';
import Calender from '../Appointement/Calender';
import UsersubmitData from './UsersubmitData';
import bg from '../../img/dash.jpg'
import AOS from 'aos';
import 'aos/dist/aos.css';
const DeshbordHome = () => {
    const [date, setDate] = useState(new Date())
    const appointmentBanner = {
        background: `url(${bg})`,
        backgroundColor: 'rgba(45, 58, 74, 0.9)',
        backgroundBlendMode: 'multiply',
        backgroundRepeat: 'repeat-x',
        opacity: '3.9'

    }
    AOS.init();

    return (
        <div style={appointmentBanner} className="ba p-2 text-white">
            <div className="row">
                <div className="col-md-5 col-sm-6">
                    <div
                     data-aos="fade-right"
                     data-aos-offset="300"
                     data-aos-easing="ease-in-sine"
                    className="">
                        <Calender date={date} setDate={setDate}></Calender>
                    </div>
                </div>
                <div 
                data-aos="fade-down"
                data-aos-easing="linear"
                data-aos-duration="1500"
                className="col-md-7 col-sm-6 ">

                    <UsersubmitData date={date}></UsersubmitData>
                </div>

            </div>
        </div>
    );
};

export default DeshbordHome;